/**
 * caseListColumns.js — opt-in column bookkeeping for the All Cases table.
 *
 * Column choice is stored as the HIDDEN set (localStorage and saved views), so
 * a column added later would normally pop up for everyone who already has a
 * stored choice. Opt-in columns must not: each stored choice now also records
 * the columns it knew about (`knownCols`), and an opt-in column the choice has
 * never seen starts hidden. Choices stored before `knownCols` existed are
 * treated as knowing LEGACY_KNOWN_COLS — so an earlier "show SLA" is kept.
 */

/** Off until the user turns them on. */
export const OPT_IN_COLS = Object.freeze(['sla', 'incidentCategory']);
export const DEFAULT_HIDDEN_COLS = OPT_IN_COLS;

/** Every column that existed before knownCols was recorded. Never add to this. */
export const LEGACY_KNOWN_COLS = Object.freeze([
  'clinic', 'treatment', 'severity', 'status', 'staffMember',
  'reportedDate', 'lastActivity', 'sla', 'cost',
]);

/** Every optional column field (incl. role/flag-gated ones). Append new ones here. */
export const ALL_COLS = Object.freeze([...LEGACY_KNOWN_COLS, 'incidentCategory']);

/** Hidden set with every opt-in column the stored choice never saw added. */
export function withUnseenOptInsHidden(hidden, knownCols) {
  const known = new Set(Array.isArray(knownCols) ? knownCols : LEGACY_KNOWN_COLS);
  const out = new Set(hidden);
  for (const c of OPT_IN_COLS) if (!known.has(c)) out.add(c);
  return out;
}
